import { Component, OnInit } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.sass']
})
export class MainComponent implements OnInit {

  constructor(public auth: AuthService) { }

  searchBool = false
  searchCat: string
  searchVal: string
  reload: any
  ngOnInit(): void {
  }

  searching(val) {
    this.searchVal = val[0]
    this.searchCat = val[1]
    this.searchBool = true
  }
  
  backing() {
    this.searchBool = false
  }

  reloadMainPostData(val) {
      this.reload = val
  }
}